import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CaseService {
 
    case: any;
    page: any;
    attacmentList:any=[];


    editFromDetailsPage=false;

    tabs:any=[
        {"basicInformationPageShow":true, "completed":false, "visited":true},
        {"reportDataPageShow":false, "completed":false, "visited":false},
        {"evidencePageShow":false, "completed":false, "visited":false},
        {"addressesPageShow":false, "completed":false, "visited":false},
      ]
    tabsFraud:any=[
        {"basicInformationPageShow":true, "completed":false, "visited":true},
        {"reportInformationPageShow":false, "completed":false, "visited":false},
        {"addressPageShow":false, "completed":false, "visited":false},
    ]
    violationTabs:any=[
        {"basicInformationPageShow":true, "completed":false, "visited":true},
        {"offendersPageShow":false, "completed":false, "visited":false},
        {"attachmentPageShow":false, "completed":false, "visited":false},
        {"delegatePageShow":false, "completed":false, "visited":false},
    ];
    

    setCaseData(caseObj){
        this.case=caseObj;
    }
    getCaseData() {
        return this.case;
    }
    //setFraudCaseData(caseObj){
    //    this.fraudCase=caseObj;
    //    this.case = caseObj;
    //}
    setAttachmentList(attch){
        this.attacmentList=attch;
    }
    getAttachmentList(){
        return this.attacmentList;
    }

    WhatIsNextViolationTab(index:number){
        const prevKeys = Object.keys(this.violationTabs[index-1])
        const nextKeys = Object.keys(this.violationTabs[index])
        let prevPageName=prevKeys[0];
        let NextPageName=nextKeys[0];

        this.violationTabs[index-1][prevPageName]=false;
        this.violationTabs[index-1]["completed"]=true;

        this.violationTabs[index][NextPageName]=true;
        this.violationTabs[index]["visited"]=true;
        if(index==1){
            this.violationTabs[index + 1]["visited"]=true;
            this.violationTabs[index + 2]["visited"]=true;
        }

    }
    WhatIsNext(index:number,allowAddReport){
        if(!allowAddReport){
            const firstKeysBasicInfo = Object.keys(this.tabs[index-2])
            let firstPageName=firstKeysBasicInfo[0];
            this.tabs[index-2][firstPageName]=false;
            this.tabs[index-2]["completed"]=true;
        }
        const prevKeys = Object.keys(this.tabs[index-1])
        const nextKeys = Object.keys(this.tabs[index])
        
        let prevPageName=prevKeys[0];
        let NextPageName=nextKeys[0];
        
        this.tabs[index-1][prevPageName]=false;
        this.tabs[index-1]["completed"]=true;
        
        this.tabs[index][NextPageName]=true;
        this.tabs[index]["visited"]=true;
        if(index==1){
            this.tabs[index + 1]["visited"]=true;
            this.tabs[index + 2]["visited"]=true;
        }
        else if(index==2){
            this.tabs[index + 1]["visited"]=true;
        }
        else if(index==3){
            this.tabs[0]['basicInformationPageShow']=false;
            this.tabs[0]['completed']=true;
            this.tabs[1]["visited"]=true;
            this.tabs[2]["visited"]=true;
        }
        console.log(this.tabs)
    }
    WhatIsNextFraudCase(index:number,isSpecialRight){
        if(!isSpecialRight){
            const firstKeysBasicInfo = Object.keys(this.tabsFraud[index-2])
            let firstPageName=firstKeysBasicInfo[0];
            this.tabsFraud[index-2][firstPageName]=false;
            this.tabsFraud[index-2]["completed"]=true;
        }
        
        const prevKeys = Object.keys(this.tabsFraud[index-1])
        const nextKeys = Object.keys(this.tabsFraud[index])

        let prevPageName=prevKeys[0];
        let NextPageName=nextKeys[0];

        this.tabsFraud[index-1][prevPageName]=false;
        this.tabsFraud[index-1]["completed"]=true;

        this.tabsFraud[index][NextPageName]=true;
        this.tabsFraud[index]["visited"]=true;
        if(index==1){
            this.tabsFraud[index + 1]["visited"]=true;
        }

    }

    getTabs(){
        return this.tabs;
    }
    
    
}
